export class ListSparkJobsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "sparkJobs",
            "baseName": "sparkJobs",
            "type": "Array<SparkJob>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSparkJobsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
